export const PRESCRIPTION_GET_DRUGS_REQUESTED = 'PRESCRIPTION_GET_DRUGS_REQUESTED';
export const PRESCRIPTION_GET_DRUGS_SUCCESS = 'PRESCRIPTION_GET_DRUGS_SUCCESS';
export const PRESCRIPTION_GET_DRUGS_FAILED = 'PRESCRIPTION_GET_DRUGS_FAILED';
